import { cn } from "../../lib/utils";

export type StatusDotTone = "good" | "bad" | "warn" | "neutral";

export interface StatusDotProps {
  tone: StatusDotTone;
  label?: string;
  className?: string;
}

const toneVar: Record<StatusDotTone, string> = {
  good: "var(--color-good)",
  bad: "var(--color-bad)",
  warn: "var(--color-warn)",
  neutral: "var(--color-ink-3)",
};

/** Ponto de status (ex.: nao lida em Notificacoes, saude de deposito em Estoques). */
export function StatusDot({ tone, label, className }: StatusDotProps): JSX.Element {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <span
        aria-hidden
        style={{
          display: "inline-block",
          width: ".5rem",
          height: ".5rem",
          borderRadius: "50%",
          background: toneVar[tone],
          flexShrink: 0,
        }}
      />
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
